import { SyncSDK, HtmlVideoPlayer, Callbacks } from '@sscale/syncsdk';
import iOS from "../helper/iosDetect";


let syncInstance;

export const initializeSyncSdk = () => {
  syncInstance = new SyncSDK(encodeURIComponent(process.env.REACT_APP_SYNC_TOKEN))
}

export const selectGroupName = (groupId, clientName) => {
  if(groupId && clientName)
    syncInstance.createGroup(groupId, clientName);
}
export const stopSync = () => {
  syncInstance.stopSynchronize();
}

export const setClientToSdk = (player) => {
  const playerInstance = document.getElementById(player.id);
  if(iOS()){
    playerInstance.playsInline = true;
    playerInstance.autoPlay = true;
    playerInstance.muted = true;
    playerInstance.src = player.videoUrl;
  }else {
    playerInstance.autoPlay = true;
  }
  const playerObj = new HtmlVideoPlayer({ id: player.id, videoUrl: player.videoUrl })
  playerObj.setPlayerInstance(playerInstance)
  syncInstance.addPlayer(playerObj, player.playerType)
  setTimeout(() => {
    if(playerInstance){
      try{
        playerInstance.play();
      }catch(err){
        console.log(err)
      }
    }
  }, 2000)
}

export const startSynchronize = () => {
  syncInstance.startSynchronize()
}

export const listenGroup = (cb) => {
syncInstance.attachListener((data) => {
  cb(data)
} , Callbacks.receive_command)
}
export const sendGroup = (payload) => {
  syncInstance.sendEventToGroup(payload)
}
